import { use } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { getFormatedSize, getTestProps } from '../../../lib/helpers';

import LinkButton from '../../../components/LinkButton/LinkButton';
import ProgressBar from '../../../components/ProgressBar/ProgressBar';
import Tooltip from '../../../components/Tooltip/Tooltip';

import useSelectedSpace from '../../../hooks/useSelectedSpace';

import UserContext from '../../../contexts/UserContext';

import { WarningIcon } from '../../../images/shapes';

const MediaSecondaryTopar = ({
  mediaSumSize,
  testId,
}: {
  mediaSumSize: string | number;
  testId?: string;
}) => {
  const { t } = useTranslation();
  const { isAdmin } = use(UserContext);
  const { space, spaceLimits } = useSelectedSpace();

  if (!spaceLimits?.file_quota) return null;

  return (
    <div
      className={`ml-auto flex items-center justify-end w-auto px-2 sm:px-4
          ${spaceLimits?.file_quota > -1 ? 'md:w-[700px]' : 'md:w-[570px]'}`}
      {...getTestProps(testId, 'media-plan-usage')}
    >
      <Tooltip
        tooltip={t('Media.SpaceUsageTooltip')}
        tooltipPlacement="bottomCenter"
        phoneTooltipPlacement="bottomLeft"
        additionalClasses="ml-2 md:ml-0! mr-2 z-10"
        additionalTooltipClasses="rounded-tr mt-0"
      >
        <WarningIcon className="w-3.5 h-3.5 text-blue" />
      </Tooltip>
      <ProgressBar
        progressBarLabel={t('Media.SpaceUsage')}
        outOfCompletionValue={getFormatedSize(
          mediaSumSize,
          t('Global.Unlimited'),
          'file-size',
        )}
        outOfCompletionTotalValue={getFormatedSize(
          spaceLimits.file_quota,
          t('Global.Unlimited'),
          'file-size',
        )}
        completionPercentValue={
          spaceLimits.file_quota > 0
            ? (+mediaSumSize / spaceLimits.file_quota) * 100
            : -1
        }
        barThickness={'thin'}
        hidePercentValue
        additionalLabelClasses={twMerge('whitespace-nowrap text-sm! mb-0 mr-3')}
        additionalCompletionValuesContainerClasses={twMerge(
          'mb-px mr-3 whitespace-nowrap leading-none',
        )}
        additionalContainerClasses={twMerge(
          'text-sm! md:text-base! grow w-auto flex-row flex-wrap sm:flex-nowrap items-center',
        )}
        additionalBarClasses="hidden sm:block"
      />

      <div className="flex items-center justify-end">
        {spaceLimits?.price !== -1 && isAdmin && (
          <LinkButton
            buttonSize="sm"
            additionalClasses={twMerge(
              'whitespace-nowrap h-6 2xl:h-6 text-sm px-2 ml-2 md:ml-5',
            )}
            link={`/space/upgrade/${space}`}
          >
            {t('Global.UpgradePlan')}
          </LinkButton>
        )}
      </div>
    </div>
  );
};

export default MediaSecondaryTopar;
